import {Component, OnInit} from "@angular/core";
import {ChannelConfig} from "../../../../model/channels.model";
import {UtilsService} from "../../../../services/utils.service";
import {LookupService} from "../../lookup.service";

@Component({
  selector: "admin-lookup-common-tabs",
  templateUrl: "./tabs.component.html",
  styleUrls: ["./tabs.component.css"]
})
export class AdminLookupCommonTabsComponent {

  constructor(
    private singleService: LookupService,
  ) {
  }

  get channels(): ChannelConfig[] {
    return this.singleService.channels;
  }

  isSelected(channel: ChannelConfig) {
    if (channel && this.singleService.definition.config) {
      if (UtilsService.channelId(channel) == UtilsService.channelId(this.singleService.definition.config!)) {
        return true;
      }
    }
    return false;
  }

  selectChannel(channel: ChannelConfig) {
    this.singleService.select(channel);
  }
}
